import {BuildingTypeForm, BuildingTypeFormProps} from "./BuildingTypeForm";
import {PopupForm} from "@tracabois/components";

export interface BuildingTypeFormPopupProps extends BuildingTypeFormProps {
  open: boolean
}

export const BuildingTypeFormPopup = (props: BuildingTypeFormPopupProps) => {
  const {open, ...buildingTypeFormProps} = props
  const title = !buildingTypeFormProps.item?.id ? "Création d'un type de bâtiment" : "Type de bâtiment"
  return (
    <PopupForm open={open} onClose={buildingTypeFormProps.onCancel} title={title}>
      <BuildingTypeForm
        {...buildingTypeFormProps}
      />
    </PopupForm>
  )
};
